import React, { useState, useEffect } from 'react';
import AppHeader from '../components/AppHeader';


// ── NUMÉROS UTILES PAR CATÉGORIE ─────────────────────────────────────────────
const NUMEROS_UTILES = {
  caf: {
    titre: 'Contacts CAF / RSA / AAH',
    contacts: [
      { icon: '📞', label: 'CAF — Allocations familiales', numero: '3230', detail: 'Lun-Ven 9h-17h · Gratuit depuis fixe' },
      { icon: '🌐', label: 'Mon espace CAF', url: 'https://www.caf.fr', detail: 'Accès à votre dossier en ligne' },
      { icon: '📞', label: 'AAH — MDPH de votre département', numero: 'mdph.fr', detail: 'Voir le site pour votre département' },
      { icon: '🌐', label: 'Simulateur droits CAF', url: 'https://wwwd.caf.fr/wps/portal/caffr/simulateurdemesaides', detail: 'Calculez vos droits gratuitement' },
    ],
  },
  sante: {
    titre: 'Contacts CPAM / Santé',
    contacts: [
      { icon: '📞', label: 'Assurance Maladie — Ameli', numero: '3646', detail: 'Lun-Ven 8h30-17h30 · Gratuit' },
      { icon: '🌐', label: 'Mon compte Ameli', url: 'https://www.ameli.fr', detail: 'Gérez vos remboursements en ligne' },
      { icon: '📞', label: 'Médecin de garde', numero: '15 ou 116 117', detail: 'Urgences médicales · 24h/24' },
      { icon: '🌐', label: 'Trouver un médecin', url: 'https://www.doctolib.fr', detail: 'Prise de rendez-vous en ligne' },
    ],
  },
  logement: {
    titre: 'Contacts Logement / Bailleur',
    contacts: [
      { icon: '📞', label: 'ADIL — Conseil logement gratuit', numero: '0 805 160 075', detail: 'Gratuit · Conseil juridique logement' },
      { icon: '🌐', label: 'ADIL — Agence Dépt Info Logement', url: 'https://www.anil.org', detail: 'Trouver votre ADIL locale' },
      { icon: '📞', label: 'Urgence logement / SIAO', numero: '115', detail: "Hébergement d'urgence · 24h/24" },
      { icon: '🌐', label: 'Demande logement social', url: 'https://www.demande-logement-social.gouv.fr', detail: 'Dossier en ligne officiel' },
    ],
  },
  impots: {
    titre: 'Contacts Impôts / Dettes',
    contacts: [
      { icon: '📞', label: 'Impôts — Renseignements', numero: '0 809 401 401', detail: 'Lun-Ven 8h30-19h · Service gratuit' },
      { icon: '🌐', label: 'impots.gouv.fr', url: 'https://www.impots.gouv.fr', detail: 'Votre espace personnel en ligne' },
      { icon: '📞', label: 'Surendettement — Banque de France', numero: '3414', detail: 'Gratuit - Dossier surendettement' },
      { icon: '🌐', label: 'Point Conseil Budget', url: 'https://www.mesdroitssociaux.gouv.fr', detail: 'Bilan de situation financière gratuit' },
    ],
  },
  travail: {
    titre: 'Contacts Travail / RH',
    contacts: [
      { icon: '📞', label: 'France Travail (Pôle Emploi)', numero: '3949', detail: 'Lun-Ven 8h-20h · Gratuit' },
      { icon: '🌐', label: 'francetravail.fr', url: 'https://www.francetravail.fr', detail: "Votre espace demandeur d'emploi" },
      { icon: '📞', label: 'Inspection du travail', numero: '08 06 000 126', detail: 'Conseils sur vos droits au travail' },
      { icon: '🌐', label: 'Code du travail numérique', url: 'https://code.travail.gouv.fr', detail: 'Vos droits expliqués simplement' },
    ],
  },
  retraite: {
    titre: 'Contacts Retraite / Pension',
    contacts: [
      { icon: '📞', label: 'Assurance retraite', numero: '3960', detail: 'Lun-Ven 8h-17h · Gratuit' },
      { icon: '🌐', label: 'info-retraite.fr', url: 'https://www.info-retraite.fr', detail: 'Relevé de carrière et simulation' },
      { icon: '📞', label: 'CNAV — Retraite salariés', numero: '39 60', detail: 'Lun-Ven 8h-17h · Gratuit' },
      { icon: '🌐', label: 'Mon compte retraite', url: 'https://www.lassuranceretraite.fr', detail: 'Suivi de votre dossier en ligne' },
    ],
  },
  autre: {
    titre: 'Contacts utiles généraux',
    contacts: [
      { icon: '📞', label: 'CCAS — Centre Communal Action Sociale', numero: 'Votre mairie', detail: 'Aide sociale locale · Gratuit' },
      { icon: '📞', label: 'Numéro national prévention suicide', numero: '3114', detail: '24h/24 · Gratuit · Confidentiel' },
      { icon: '🌐', label: 'France Services', url: 'https://www.france-services.gouv.fr', detail: 'Accompagnement démarches près de chez vous' },
      { icon: '🌐', label: 'Mes droits sociaux', url: 'https://www.mesdroitssociaux.gouv.fr', detail: 'Simulateur de droits officiels' },
    ],
  },
};


// ── PROMPTS MISTRAL PAR MODE ────────────────────────────────────────────────

const PROMPT_BASE_RULES = `Tu es un assistant d'aide administrative francophone. Tu analyses des courriers officiels pour des personnes en difficulté face aux démarches administratives. Tu ne donnes jamais de conseil juridique. Tu ne fais jamais semblant de savoir ce que tu ne sais pas.
RÈGLES ABSOLUES :
- Si une information n'est pas présente dans le texte, tu écris "Non précisé dans le courrier".
- Si le courrier mentionne des montants en euros, tu les inclus avec les chiffres exacts.
- Tu vouvoies toujours l'utilisateur.
- Tu utilises des phrases courtes, simples, sans jargon administratif.
- Tu ne donnes jamais de conseil juridique.
- RÈGLE STRICTE alerte_juridique : false par défaut. True UNIQUEMENT si action juridique déjà engagée : huissier mandaté, saisie en cours, assignation tribunal, mise en demeure avec délai légal chiffré.
- Les formulations "la loi punit quiconque", "en cas de fraude", "articles L.114", "obligation de signaler" ne déclenchent JAMAIS alerte_juridique.
- Tu traites le texte en mémoire uniquement.`;

const PROMPT_EXPLIQUE = `${PROMPT_BASE_RULES}

MODE : EXPLICATION SIMPLE
Ton objectif : expliquer ce courrier en français clair, comme si tu l'expliquais à quelqu'un de 70 ans qui n'a jamais fait de démarches administratives. Utilise des mots du quotidien.

FORMAT JSON STRICT — aucun texte hors JSON, aucun markdown :
{"expediteur":"string","resume":"string — 3 phrases max, mots très simples, vouvoiement","urgence":"haute|moyenne|faible|inconnue","delai_brut":"string","delai_interpretation":"string","actions":[{"priorite":"rouge|orange|vert","texte":"string — action simple et concrète","delai":"string"}],"module_recommande":"courrier|pdf|email|dossier|securite|impots|cartevitale|rsacaf|logement|dossiermedical|formation|permis|banque|smartphone|aucun","module_raison":"string","alerte_juridique":false,"alerte_juridique_message":"","incertitude":"string ou Aucune"}
PRIORITÉ : rouge = 48h ou moins / orange = 3 à 15 jours / vert = informatif`;

const PROMPT_PROCEDURE = `${PROMPT_BASE_RULES}

MODE : PROCÉDURE COMPLÈTE
Ton objectif : générer la liste complète et ordonnée des étapes à suivre, avec les délais précis, les documents nécessaires, et les risques en cas de non-action.

FORMAT JSON STRICT — aucun texte hors JSON, aucun markdown :
{"expediteur":"string","resume":"string — résumé factuel et complet","urgence":"haute|moyenne|faible|inconnue","delai_brut":"string","delai_interpretation":"string","actions":[{"priorite":"rouge|orange|vert","texte":"string — étape détaillée et actionnable","delai":"string","documents":"string — documents requis pour cette étape si applicable"}],"risques":"string — conséquences en cas de non-action","module_recommande":"courrier|pdf|email|dossier|securite|impots|cartevitale|rsacaf|logement|dossiermedical|formation|permis|banque|smartphone|aucun","module_raison":"string","alerte_juridique":false,"alerte_juridique_message":"","incertitude":"string ou Aucune"}
PRIORITÉ : rouge = 48h ou moins / orange = 3 à 15 jours / vert = informatif`;

const PROMPT_COURRIER = `${PROMPT_BASE_RULES}

MODE : GÉNÉRATION DE COURRIER DE RÉPONSE
Ton objectif : rédiger un courrier de réponse prêt à envoyer, adapté à la situation. Le courrier doit être formel, poli, clair, et efficace. Il doit inclure les formules de politesse appropriées.

FORMAT JSON STRICT — aucun texte hors JSON, aucun markdown :
{"expediteur":"string","resume":"string — résumé de la situation nécessitant une réponse","urgence":"haute|moyenne|faible|inconnue","delai_brut":"string","delai_interpretation":"string","courrier_genere":"string — courrier complet prêt à envoyer, avec Objet, corps, formule de politesse. Utiliser \\n pour les sauts de ligne.","instructions_envoi":"string — comment et où envoyer ce courrier","module_recommande":"courrier|pdf|email|dossier|securite|impots|cartevitale|rsacaf|logement|dossiermedical|formation|permis|banque|smartphone|aucun","module_raison":"string","alerte_juridique":false,"alerte_juridique_message":"","incertitude":"string ou Aucune"}
PRIORITÉ : rouge = 48h ou moins / orange = 3 à 15 jours / vert = informatif`;

const PROMPT_DETECTE = `${PROMPT_BASE_RULES}

MODE : DÉTECTION DE PROBLÈMES
Ton objectif : analyser ce courrier pour détecter les éléments flous, contradictoires, suspects, abusifs ou illégaux. Alerter sur ce qui ne va pas.

FORMAT JSON STRICT — aucun texte hors JSON, aucun markdown :
{"expediteur":"string","resume":"string — résumé objectif du courrier","urgence":"haute|moyenne|faible|inconnue","delai_brut":"string","delai_interpretation":"string","problemes_detectes":[{"type":"flou|contradiction|suspect|abusif|illegal|omission","description":"string — description précise du problème détecté","recommandation":"string — que faire face à ce problème"}],"legitimite":"legitime|suspect|inconnu","actions":[{"priorite":"rouge|orange|vert","texte":"string — action concrète","delai":"string"}],"module_recommande":"courrier|pdf|email|dossier|securite|impots|cartevitale|rsacaf|logement|dossiermedical|formation|permis|banque|smartphone|aucun","module_raison":"string","alerte_juridique":false,"alerte_juridique_message":"","incertitude":"string ou Aucune"}`;

const PROMPTS = {
  expliquer:  PROMPT_EXPLIQUE,
  procedure:  PROMPT_PROCEDURE,
  courrier:   PROMPT_COURRIER,
  detecter:   PROMPT_DETECTE,
};

// ── TEXTES UI 7 LANGUES ─────────────────────────────────────────────────────

const QF_UI = {
  fr: {
    badge: 'URGENCE — Que faire ?',
    title: 'Vous avez un courrier devant vous ?',
    intro: "Collez le texte ci-dessous. Choisissez votre mode d'analyse et la catégorie — on fait le reste.",
    labelCategorie: 'Catégorie',
    labelMode: "Mode d'analyse",
    labelTexte: 'Texte du courrier',
    placeholder: 'Copiez-collez ici le texte de votre courrier officiel...',
    labelCtx: 'Contexte supplémentaire',
    optional: '(optionnel)',
    placeholderCtx: 'Ex : courrier CAF, mise en demeure, lettre des impôts...',
    btnAnalyser: 'Analyser ce courrier →',
    btnLoading: '⏳ Analyse en cours...',
    disclaimer: "Votre texte est analysé immédiatement et n'est pas conservé. Cet outil ne remplace pas un conseil juridique.",
    erreur: "L'analyse n'a pas pu aboutir. Vérifiez votre connexion et réessayez.",
    infoManquante: 'Information manquante :',
    blocDit: "Ce qu'ils disent",
    blocVeulent: "Ce qu'ils veulent",
    delaiLabel: 'Délai indiqué :',
    blocFaites: 'Ce que vous faites',
    blocRisques: 'Risques en cas de non-action',
    blocCourrier: 'Votre courrier de réponse',
    btnCopier: '📋 Copier le courrier',
    btnCopie: '✅ Copié !',
    instructionsEnvoi: "Comment envoyer ce courrier",
    blocProblemes: 'Problèmes détectés',
    legitimite: { legitime: '✅ Courrier légitime', suspect: '⚠️ Courrier suspect', inconnu: 'ℹ️ Légitimité incertaine' },
    blocPlus: 'Pour aller plus loin',
    btnModule: 'Accéder au module →',
    disclaimerFin: "Cette analyse est fournie à titre informatif. Elle ne constitue pas un conseil juridique. En cas de doute, consultez un professionnel ou le CCAS de votre mairie.",
    btnReset: '← Analyser un autre courrier',
    backLabel: 'Accueil',
    categories: {
      caf:      { label: 'CAF / RSA / AAH',        icon: '🏛️' },
      sante:    { label: 'CPAM / Santé',            icon: '💊' },
      logement: { label: 'Logement / Bailleur',     icon: '🏠' },
      impots:   { label: 'Impôts / Dettes',         icon: '🧾' },
      travail:  { label: 'Travail / RH',            icon: '💼' },
      retraite: { label: 'Retraite / Pension',      icon: '🎖️' },
      autre:    { label: 'Autre',                   icon: '📋' },
    },
    modes: {
      expliquer: { label: 'Expliquer simplement', icon: '🔍', desc: 'Je veux comprendre ce courrier en mots simples' },
      procedure: { label: 'Procédure complète',   icon: '📋', desc: 'Je veux toutes les étapes à suivre' },
      courrier:  { label: 'Générer un courrier',  icon: '✉️', desc: 'Je veux une réponse prête à envoyer' },
      detecter:  { label: 'Détecter les problèmes', icon: '⚠️', desc: 'Je veux savoir si ce courrier est normal' },
    },
    urgences: {
      haute:    { label: 'Urgence haute' },
      moyenne:  { label: 'Urgence moyenne' },
      faible:   { label: 'Faible urgence' },
      inconnue: { label: 'Non déterminée' },
    },
    priorites: {
      rouge:  { label: 'Urgent' },
      orange: { label: 'Sous 15j' },
      vert:   { label: 'Info' },
    },
    problemeTypes: {
      flou: 'Flou', contradiction: 'Contradiction', suspect: 'Suspect',
      abusif: 'Abusif', illegal: 'Illégal', omission: 'Omission',
    },
    aucunDelai: 'Aucun délai précis',
  },
  en: {
    badge: 'EMERGENCY — What to do?',
    title: 'Do you have a letter in front of you?',
    intro: "Paste the text below. Choose your analysis mode and category — we'll do the rest.",
    labelCategorie: 'Category',
    labelMode: 'Analysis mode',
    labelTexte: 'Letter text',
    placeholder: 'Copy and paste the text of your official letter here...',
    labelCtx: 'Additional context',
    optional: '(optional)',
    placeholderCtx: 'E.g.: CAF letter, formal notice, tax letter...',
    btnAnalyser: 'Analyse this letter →',
    btnLoading: '⏳ Analysing...',
    disclaimer: 'Your text is analysed immediately and is not stored. This tool does not replace legal advice.',
    erreur: 'The analysis could not be completed. Check your connection and try again.',
    infoManquante: 'Missing information:',
    blocDit: 'What they say',
    blocVeulent: 'What they want',
    delaiLabel: 'Indicated deadline:',
    blocFaites: 'What you need to do',
    blocRisques: 'Risks if you do not act',
    blocCourrier: 'Your reply letter',
    btnCopier: '📋 Copy letter',
    btnCopie: '✅ Copied!',
    instructionsEnvoi: 'How to send this letter',
    blocProblemes: 'Problems detected',
    legitimite: { legitime: '✅ Legitimate letter', suspect: '⚠️ Suspicious letter', inconnu: 'ℹ️ Legitimacy uncertain' },
    blocPlus: 'To go further',
    btnModule: 'Go to module →',
    disclaimerFin: 'This analysis is provided for information only. It does not constitute legal advice. If in doubt, consult a professional or your local CCAS.',
    btnReset: '← Analyse another letter',
    backLabel: 'Home',
    categories: {
      caf:      { label: 'CAF / RSA / AAH',        icon: '🏛️' },
      sante:    { label: 'CPAM / Health',           icon: '💊' },
      logement: { label: 'Housing / Landlord',      icon: '🏠' },
      impots:   { label: 'Tax / Debts',             icon: '🧾' },
      travail:  { label: 'Work / HR',               icon: '💼' },
      retraite: { label: 'Retirement / Pension',    icon: '🎖️' },
      autre:    { label: 'Other',                   icon: '📋' },
    },
    modes: {
      expliquer: { label: 'Explain simply',     icon: '🔍', desc: 'I want to understand this letter in plain words' },
      procedure: { label: 'Full procedure',     icon: '📋', desc: 'I want all the steps to follow' },
      courrier:  { label: 'Generate a letter',  icon: '✉️', desc: 'I want a reply ready to send' },
      detecter:  { label: 'Detect problems',    icon: '⚠️', desc: 'I want to know if this letter is normal' },
    },
    urgences: {
      haute:    { label: 'High urgency' },
      moyenne:  { label: 'Medium urgency' },
      faible:   { label: 'Low urgency' },
      inconnue: { label: 'Undetermined' },
    },
    priorites: {
      rouge:  { label: 'Urgent' },
      orange: { label: 'Within 15 days' },
      vert:   { label: 'Info' },
    },
    problemeTypes: {
      flou: 'Vague', contradiction: 'Contradiction', suspect: 'Suspicious',
      abusif: 'Abusive', illegal: 'Illegal', omission: 'Omission',
    },
    aucunDelai: 'No specific deadline',
  },
  it: {
    badge: 'URGENZA — Cosa fare?',
    title: 'Hai una lettera davanti a te?',
    intro: "Incolla il testo qui sotto. Scegli la modalità di analisi e la categoria — ci pensiamo noi.",
    labelCategorie: 'Categoria',
    labelMode: 'Modalità di analisi',
    labelTexte: 'Testo della lettera',
    placeholder: 'Copia e incolla qui il testo della tua lettera ufficiale...',
    labelCtx: 'Contesto aggiuntivo',
    optional: '(facoltativo)',
    placeholderCtx: 'Es.: lettera CAF, diffida, lettera delle tasse...',
    btnAnalyser: 'Analizza questa lettera →',
    btnLoading: '⏳ Analisi in corso...',
    disclaimer: 'Il tuo testo viene analizzato immediatamente e non viene conservato. Questo strumento non sostituisce una consulenza legale.',
    erreur: "L'analisi non ha potuto essere completata. Controlla la connessione e riprova.",
    infoManquante: 'Informazione mancante:',
    blocDit: 'Cosa dicono',
    blocVeulent: 'Cosa vogliono',
    delaiLabel: 'Scadenza indicata:',
    blocFaites: 'Cosa fare',
    blocRisques: 'Rischi in caso di non azione',
    blocCourrier: 'La tua lettera di risposta',
    btnCopier: '📋 Copia la lettera',
    btnCopie: '✅ Copiato!',
    instructionsEnvoi: 'Come inviare questa lettera',
    blocProblemes: 'Problemi rilevati',
    legitimite: { legitime: '✅ Lettera legittima', suspect: '⚠️ Lettera sospetta', inconnu: 'ℹ️ Legittimità incerta' },
    blocPlus: 'Per approfondire',
    btnModule: 'Vai al modulo →',
    disclaimerFin: "Questa analisi è fornita a solo scopo informativo. Non costituisce una consulenza legale. In caso di dubbio, rivolgiti a un professionista o al CCAS del tuo comune.",
    btnReset: '← Analizza un\'altra lettera',
    backLabel: 'Home',
    categories: {
      caf:      { label: 'CAF / RSA / AAH',           icon: '🏛️' },
      sante:    { label: 'CPAM / Salute',              icon: '💊' },
      logement: { label: 'Alloggio / Locatore',        icon: '🏠' },
      impots:   { label: 'Imposte / Debiti',           icon: '🧾' },
      travail:  { label: 'Lavoro / HR',                icon: '💼' },
      retraite: { label: 'Pensione / Previdenza',      icon: '🎖️' },
      autre:    { label: 'Altro',                      icon: '📋' },
    },
    modes: {
      expliquer: { label: 'Spiegare semplicemente', icon: '🔍', desc: 'Voglio capire questa lettera con parole semplici' },
      procedure: { label: 'Procedura completa',     icon: '📋', desc: 'Voglio tutti i passi da seguire' },
      courrier:  { label: 'Generare una risposta',  icon: '✉️', desc: 'Voglio una risposta pronta da inviare' },
      detecter:  { label: 'Rilevare problemi',      icon: '⚠️', desc: 'Voglio sapere se questa lettera è normale' },
    },
    urgences: {
      haute: { label: 'Urgenza alta' }, moyenne: { label: 'Urgenza media' },
      faible: { label: 'Urgenza bassa' }, inconnue: { label: 'Non determinata' },
    },
    priorites: { rouge: { label: 'Urgente' }, orange: { label: 'Entro 15 giorni' }, vert: { label: 'Info' } },
    problemeTypes: {
      flou: 'Vago', contradiction: 'Contraddizione', suspect: 'Sospetto',
      abusif: 'Abusivo', illegal: 'Illegale', omission: 'Omissione',
    },
    aucunDelai: 'Nessuna scadenza precisa',
  },
  es: {
    badge: 'URGENCIA — ¿Qué hacer?',
    title: '¿Tienes una carta delante?',
    intro: "Pega el texto abajo. Elige el modo de análisis y la categoría — nosotros hacemos el resto.",
    labelCategorie: 'Categoría',
    labelMode: 'Modo de análisis',
    labelTexte: 'Texto de la carta',
    placeholder: 'Copia y pega aquí el texto de tu carta oficial...',
    labelCtx: 'Contexto adicional',
    optional: '(opcional)',
    placeholderCtx: 'Ej.: carta CAF, requerimiento, carta de impuestos...',
    btnAnalyser: 'Analizar esta carta →',
    btnLoading: '⏳ Analizando...',
    disclaimer: 'Tu texto se analiza inmediatamente y no se conserva. Esta herramienta no sustituye el asesoramiento legal.',
    erreur: 'El análisis no pudo completarse. Comprueba tu conexión e inténtalo de nuevo.',
    infoManquante: 'Información faltante:',
    blocDit: 'Qué dicen',
    blocVeulent: 'Qué quieren',
    delaiLabel: 'Plazo indicado:',
    blocFaites: 'Qué debes hacer',
    blocRisques: 'Riesgos si no actúas',
    blocCourrier: 'Tu carta de respuesta',
    btnCopier: '📋 Copiar la carta',
    btnCopie: '✅ ¡Copiado!',
    instructionsEnvoi: 'Cómo enviar esta carta',
    blocProblemes: 'Problemas detectados',
    legitimite: { legitime: '✅ Carta legítima', suspect: '⚠️ Carta sospechosa', inconnu: 'ℹ️ Legitimidad incierta' },
    blocPlus: 'Para ir más lejos',
    btnModule: 'Ir al módulo →',
    disclaimerFin: "Este análisis se facilita a título informativo. No constituye asesoramiento jurídico. En caso de duda, consulta a un profesional o al CCAS de tu municipio.",
    btnReset: '← Analizar otra carta',
    backLabel: 'Inicio',
    categories: {
      caf:      { label: 'CAF / RSA / AAH',          icon: '🏛️' },
      sante:    { label: 'CPAM / Salud',              icon: '💊' },
      logement: { label: 'Vivienda / Arrendador',     icon: '🏠' },
      impots:   { label: 'Impuestos / Deudas',        icon: '🧾' },
      travail:  { label: 'Trabajo / RRHH',            icon: '💼' },
      retraite: { label: 'Jubilación / Pensión',      icon: '🎖️' },
      autre:    { label: 'Otro',                      icon: '📋' },
    },
    modes: {
      expliquer: { label: 'Explicar fácilmente',   icon: '🔍', desc: 'Quiero entender esta carta con palabras sencillas' },
      procedure: { label: 'Procedimiento completo', icon: '📋', desc: 'Quiero todos los pasos a seguir' },
      courrier:  { label: 'Generar respuesta',      icon: '✉️', desc: 'Quiero una respuesta lista para enviar' },
      detecter:  { label: 'Detectar problemas',     icon: '⚠️', desc: 'Quiero saber si esta carta es normal' },
    },
    urgences: {
      haute: { label: 'Urgencia alta' }, moyenne: { label: 'Urgencia media' },
      faible: { label: 'Urgencia baja' }, inconnue: { label: 'No determinada' },
    },
    priorites: { rouge: { label: 'Urgente' }, orange: { label: 'Antes de 15 días' }, vert: { label: 'Info' } },
    problemeTypes: {
      flou: 'Vago', contradiction: 'Contradicción', suspect: 'Sospechoso',
      abusif: 'Abusivo', illegal: 'Ilegal', omission: 'Omisión',
    },
    aucunDelai: 'Sin plazo preciso',
  },
  zh: {
    badge: '紧急 — 该怎么办？',
    title: '您手边有一封信吗？',
    intro: "将文字粘贴到下方，选择分析模式和类别——我们来处理。",
    labelCategorie: '类别',
    labelMode: '分析模式',
    labelTexte: '信件内容',
    placeholder: '在此粘贴您的官方信件文字...',
    labelCtx: '补充背景信息',
    optional: '（可选）',
    placeholderCtx: '例如：CAF来信、催告函、税务通知...',
    btnAnalyser: '分析这封信 →',
    btnLoading: '⏳ 分析中...',
    disclaimer: '您的文字将立即分析，不会被保存。此工具不能替代法律建议。',
    erreur: '分析未能完成。请检查您的网络连接后重试。',
    infoManquante: '缺少信息：',
    blocDit: '对方说了什么',
    blocVeulent: '对方想要什么',
    delaiLabel: '注明的期限：',
    blocFaites: '您需要做什么',
    blocRisques: '不采取行动的风险',
    blocCourrier: '您的回信',
    btnCopier: '📋 复制信件',
    btnCopie: '✅ 已复制！',
    instructionsEnvoi: '如何发送这封信',
    blocProblemes: '检测到的问题',
    legitimite: { legitime: '✅ 信件合法', suspect: '⚠️ 信件可疑', inconnu: 'ℹ️ 合法性不确定' },
    blocPlus: '进一步了解',
    btnModule: '前往模块 →',
    disclaimerFin: "本分析仅供参考，不构成法律建议。如有疑问，请咨询专业人士或当地CCAS。",
    btnReset: '← 分析另一封信',
    backLabel: '首页',
    categories: {
      caf:      { label: 'CAF / RSA / AAH',   icon: '🏛️' },
      sante:    { label: 'CPAM / 健康',        icon: '💊' },
      logement: { label: '住房 / 房东',        icon: '🏠' },
      impots:   { label: '税务 / 债务',        icon: '🧾' },
      travail:  { label: '工作 / 人事',        icon: '💼' },
      retraite: { label: '退休 / 养老金',      icon: '🎖️' },
      autre:    { label: '其他',               icon: '📋' },
    },
    modes: {
      expliquer: { label: '简单解释',   icon: '🔍', desc: '我想用简单的话理解这封信' },
      procedure: { label: '完整流程',   icon: '📋', desc: '我想了解所有步骤' },
      courrier:  { label: '生成回信',   icon: '✉️', desc: '我需要一封准备好的回信' },
      detecter:  { label: '检测问题',   icon: '⚠️', desc: '我想知道这封信是否正常' },
    },
    urgences: {
      haute: { label: '高度紧急' }, moyenne: { label: '中度紧急' },
      faible: { label: '低度紧急' }, inconnue: { label: '未确定' },
    },
    priorites: { rouge: { label: '紧急' }, orange: { label: '15天内' }, vert: { label: '信息' } },
    problemeTypes: {
      flou: '模糊', contradiction: '矛盾', suspect: '可疑',
      abusif: '滥权', illegal: '违法', omission: '遗漏',
    },
    aucunDelai: '无具体期限',
  },
  pt: {
    badge: 'URGÊNCIA — O que fazer?',
    title: 'Tem uma carta à sua frente?',
    intro: "Cole o texto abaixo. Escolha o modo de análise e a categoria — tratamos do resto.",
    labelCategorie: 'Categoria',
    labelMode: 'Modo de análise',
    labelTexte: 'Texto da carta',
    placeholder: 'Cole aqui o texto da sua carta oficial...',
    labelCtx: 'Contexto adicional',
    optional: '(opcional)',
    placeholderCtx: 'Ex.: carta CAF, interpelação, carta do fisco...',
    btnAnalyser: 'Analisar esta carta →',
    btnLoading: '⏳ A analisar...',
    disclaimer: 'O seu texto é analisado imediatamente e não é guardado. Esta ferramenta não substitui um conselho jurídico.',
    erreur: 'A análise não pôde ser concluída. Verifique a sua ligação e tente novamente.',
    infoManquante: 'Informação em falta:',
    blocDit: 'O que dizem',
    blocVeulent: 'O que querem',
    delaiLabel: 'Prazo indicado:',
    blocFaites: 'O que deve fazer',
    blocRisques: 'Riscos se não agir',
    blocCourrier: 'A sua carta de resposta',
    btnCopier: '📋 Copiar a carta',
    btnCopie: '✅ Copiado!',
    instructionsEnvoi: 'Como enviar esta carta',
    blocProblemes: 'Problemas detectados',
    legitimite: { legitime: '✅ Carta legítima', suspect: '⚠️ Carta suspeita', inconnu: 'ℹ️ Legitimidade incerta' },
    blocPlus: 'Para ir mais longe',
    btnModule: 'Aceder ao módulo →',
    disclaimerFin: "Esta análise é fornecida a título informativo. Não constitui aconselhamento jurídico. Em caso de dúvida, consulte um profissional ou o CCAS da sua câmara.",
    btnReset: '← Analisar outra carta',
    backLabel: 'Início',
    categories: {
      caf:      { label: 'CAF / RSA / AAH',          icon: '🏛️' },
      sante:    { label: 'CPAM / Saúde',              icon: '💊' },
      logement: { label: 'Habitação / Senhorio',      icon: '🏠' },
      impots:   { label: 'Impostos / Dívidas',        icon: '🧾' },
      travail:  { label: 'Trabalho / RH',             icon: '💼' },
      retraite: { label: 'Reforma / Pensão',          icon: '🎖️' },
      autre:    { label: 'Outro',                     icon: '📋' },
    },
    modes: {
      expliquer: { label: 'Explicar simplesmente', icon: '🔍', desc: 'Quero compreender esta carta com palavras simples' },
      procedure: { label: 'Procedimento completo', icon: '📋', desc: 'Quero todos os passos a seguir' },
      courrier:  { label: 'Gerar uma resposta',    icon: '✉️', desc: 'Quero uma resposta pronta a enviar' },
      detecter:  { label: 'Detectar problemas',    icon: '⚠️', desc: 'Quero saber se esta carta é normal' },
    },
    urgences: {
      haute: { label: 'Urgência alta' }, moyenne: { label: 'Urgência média' },
      faible: { label: 'Urgência baixa' }, inconnue: { label: 'Não determinada' },
    },
    priorites: { rouge: { label: 'Urgente' }, orange: { label: 'Antes de 15 dias' }, vert: { label: 'Info' } },
    problemeTypes: {
      flou: 'Vago', contradiction: 'Contradição', suspect: 'Suspeito',
      abusif: 'Abusivo', illegal: 'Ilegal', omission: 'Omissão',
    },
    aucunDelai: 'Sem prazo preciso',
  },
  ar: {
    badge: 'طارئ — ماذا تفعل؟',
    title: 'هل لديك رسالة أمامك؟',
    intro: "الصق النص أدناه، اختر وضع التحليل والفئة — نحن نتكفل بالباقي.",
    labelCategorie: 'الفئة',
    labelMode: 'وضع التحليل',
    labelTexte: 'نص الرسالة',
    placeholder: 'الصق هنا نص رسالتك الرسمية...',
    labelCtx: 'سياق إضافي',
    optional: '(اختياري)',
    placeholderCtx: 'مثال: رسالة CAF، إنذار رسمي، رسالة الضرائب...',
    btnAnalyser: 'تحليل هذه الرسالة ←',
    btnLoading: '⏳ جارٍ التحليل...',
    disclaimer: 'يتم تحليل نصك فوراً ولا يتم حفظه. هذه الأداة لا تحل محل المشورة القانونية.',
    erreur: 'تعذّر إتمام التحليل. تحقق من اتصالك وأعد المحاولة.',
    infoManquante: 'معلومة مفقودة:',
    blocDit: 'ما يقولونه',
    blocVeulent: 'ما يريدونه',
    delaiLabel: 'الأجل المذكور:',
    blocFaites: 'ما يجب عليك فعله',
    blocRisques: 'المخاطر في حالة عدم التصرف',
    blocCourrier: 'رسالة ردك',
    btnCopier: '📋 نسخ الرسالة',
    btnCopie: '✅ تم النسخ!',
    instructionsEnvoi: 'كيفية إرسال هذه الرسالة',
    blocProblemes: 'المشكلات المكتشفة',
    legitimite: { legitime: '✅ رسالة رسمية', suspect: '⚠️ رسالة مشبوهة', inconnu: 'ℹ️ شرعية غير مؤكدة' },
    blocPlus: 'للمزيد',
    btnModule: 'الوصول إلى الدرس ←',
    disclaimerFin: "هذا التحليل مقدَّم لأغراض إعلامية فقط. لا يشكّل مشورة قانونية. في حالة الشك، استشر متخصصاً أو CCAS في بلديتك.",
    btnReset: 'تحليل رسالة أخرى ←',
    backLabel: 'الرئيسية',
    categories: {
      caf:      { label: 'CAF / RSA / AAH',          icon: '🏛️' },
      sante:    { label: 'CPAM / الصحة',              icon: '💊' },
      logement: { label: 'السكن / المالك',            icon: '🏠' },
      impots:   { label: 'الضرائب / الديون',          icon: '🧾' },
      travail:  { label: 'العمل / الموارد البشرية',   icon: '💼' },
      retraite: { label: 'التقاعد / المعاش',          icon: '🎖️' },
      autre:    { label: 'أخرى',                      icon: '📋' },
    },
    modes: {
      expliquer: { label: 'شرح بسيط',      icon: '🔍', desc: 'أريد فهم هذه الرسالة بكلمات بسيطة' },
      procedure: { label: 'إجراء كامل',     icon: '📋', desc: 'أريد جميع الخطوات التي يجب اتباعها' },
      courrier:  { label: 'إنشاء رد',       icon: '✉️', desc: 'أريد رداً جاهزاً للإرسال' },
      detecter:  { label: 'اكتشاف مشكلات', icon: '⚠️', desc: 'أريد معرفة ما إذا كانت هذه الرسالة طبيعية' },
    },
    urgences: {
      haute: { label: 'استعجال عالٍ' }, moyenne: { label: 'استعجال متوسط' },
      faible: { label: 'استعجال منخفض' }, inconnue: { label: 'غير محدد' },
    },
    priorites: { rouge: { label: 'عاجل' }, orange: { label: 'قبل 15 يوماً' }, vert: { label: 'معلومة' } },
    problemeTypes: {
      flou: 'غامض', contradiction: 'تناقض', suspect: 'مشبوه',
      abusif: 'تعسفي', illegal: 'مخالف للقانون', omission: 'إغفال',
    },
    aucunDelai: 'لا أجل محدد',
  },
};

const MODULE_LABELS = {
  courrier:       { label: 'Décoder un courrier officiel', icon: '📬' },
  pdf:            { label: 'Remplir un PDF',               icon: '📄' },
  email:          { label: 'Les emails',                   icon: '✉️'  },
  dossier:        { label: 'Constituer un dossier',        icon: '📁' },
  securite:       { label: 'Sécurité numérique',           icon: '🔒' },
  impots:         { label: "Déclaration d'impôts",         icon: '🧾' },
  cartevitale:    { label: 'Carte Vitale & Santé',         icon: '💊' },
  rsacaf:         { label: 'Tout sur la CAF',              icon: '🏛️' },
  logement:       { label: 'Logement & APL',               icon: '🏠' },
  dossiermedical: { label: 'Dossier médical',              icon: '🏥' },
  formation:      { label: 'Formation professionnelle',    icon: '🎓' },
  permis:         { label: 'Permis de conduire',           icon: '🚗' },
  banque:         { label: 'Compte bancaire',              icon: '🏦' },
  smartphone:     { label: 'Smartphone pour débutants',    icon: '📱' },
};

async function analyserCourrier(texte, mode, categorie) {
  const systemPrompt = PROMPTS[mode] || PROMPTS.expliquer;
  const categorieCtx = categorie && categorie !== 'autre'
    ? `\n\nCONTEXTE CATÉGORIE : Ce courrier concerne le domaine "${categorie}". Adapte ton analyse en conséquence.`
    : '';

  const res = await fetch('/api/chat', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      systemPrompt: systemPrompt + categorieCtx,
      texte: texte,
    }),
  });
  if (!res.ok) throw new Error(`Erreur API (${res.status})`);
  const data = await res.json();
  const raw = data.choices?.[0]?.message?.content?.trim() || '';
  const clean = raw.replace(/^```json\s*/,'').replace(/^```\s*/,'').replace(/```$/,'').trim();
  const parsed = JSON.parse(clean);

  // Post-traitements
  const actions = parsed.actions || [];
  const delaiNonPrecise = (parsed.delai_brut || '').toLowerCase().includes('non pr');
  const toutesVertes = actions.length > 0 && actions.every(a => a.priorite === 'vert');
  if (toutesVertes && delaiNonPrecise) {
    parsed.delai_brut = 'Aucun délai imposé';
    parsed.delai_interpretation = "Ce courrier est informatif. Vous n'avez rien à faire d'urgent.";
  }
  parsed.actions = actions.map(a => {
    if (a.priorite === 'orange' && (a.delai || '').toLowerCase().includes('non pr')) {
      return { ...a, priorite: 'vert' };
    }
    return a;
  });
  const hasRealDelai = parsed.delai_brut && !parsed.delai_brut.toLowerCase().includes('non pr') && !parsed.delai_brut.toLowerCase().includes('aucun');
  const allNotRed = (parsed.actions || []).every(a => a.priorite !== 'rouge');
  if (parsed.urgence === 'moyenne' && !hasRealDelai && allNotRed) {
    parsed.urgence = 'faible';
  }
  return parsed;
}


// ── COMPOSANT NUMÉROS UTILES ─────────────────────────────────────────────────
function NumerosUtiles({ categorie, scale, isMobile }) {
  const data = NUMEROS_UTILES[categorie];
  if (!data) return null;

  return (
    <div style={{
      background: '#F0F7FF',
      border: '1.5px solid #C7D7FF',
      borderRadius: 16,
      padding: isMobile ? '1rem' : '1.2rem',
      marginTop: 16,
    }}>
      <div style={{
        display: 'flex', alignItems: 'center', gap: 8, marginBottom: 12,
      }}>
        <span style={{ fontSize: 18 }}>📞</span>
        <div style={{
          fontSize: (isMobile ? 12 : 13) * scale,
          fontWeight: 700, color: '#003189',
          letterSpacing: '0.04em', textTransform: 'uppercase',
        }}>
          {data.titre}
        </div>
      </div>
      <div style={{
        display: 'grid',
        gridTemplateColumns: isMobile ? '1fr' : 'repeat(2, 1fr)',
        gap: 8,
      }}>
        {data.contacts.map((contact, i) => (
          <div key={i} style={{
            background: '#fff',
            border: '1px solid #E0E8FF',
            borderRadius: 10,
            padding: '10px 12px',
            display: 'flex', alignItems: 'flex-start', gap: 10,
          }}>
            <span style={{ fontSize: 16, flexShrink: 0, marginTop: 1 }}>{contact.icon}</span>
            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={{
                fontSize: (isMobile ? 11 : 12) * scale,
                fontWeight: 700, color: '#1A1A1A',
                marginBottom: 2, lineHeight: 1.3,
              }}>
                {contact.label}
              </div>
              {contact.numero && (
                <div style={{
                  fontSize: (isMobile ? 13 : 14) * scale,
                  fontWeight: 700, color: '#003189',
                  marginBottom: 2,
                }}>
                  {contact.numero}
                </div>
              )}
              {contact.url && (
                <a
                  href={contact.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    fontSize: (isMobile ? 11 : 12) * scale,
                    color: '#0063CB', textDecoration: 'none',
                    fontWeight: 600, display: 'block', marginBottom: 2,
                    wordBreak: 'break-all',
                  }}
                >
                  {contact.url.replace('https://', '')}
                </a>
              )}
              <div style={{
                fontSize: (isMobile ? 10 : 11) * scale,
                color: '#888', lineHeight: 1.35,
              }}>
                {contact.detail}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

// ── COMPOSANT PRINCIPAL ──────────────────────────────────────────────────────

export default function QueFaire({ onNavigate, large, toggleText, scale = 1, t, isRTL, lang, switchLang, onDiagnostic }) {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [categorie, setCategorie] = useState('autre');
  const [mode, setMode] = useState('expliquer');
  const [texte, setTexte] = useState('');
  const [contexte, setContexte] = useState('');
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);
  const [erreur, setErreur] = useState(null);
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    const handle = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', handle);
    return () => window.removeEventListener('resize', handle);
  }, []);

  const ui = QF_UI[lang] || QF_UI.fr;

  const handleAnalyser = async () => {
    if (!texte.trim()) return;
    setLoading(true); setResult(null); setErreur(null); setCopied(false);
    try {
      const input = contexte.trim()
        ? `Contexte : ${contexte.trim()}\n\n${texte.trim()}`
        : texte.trim();
      const parsed = await analyserCourrier(input, mode, categorie);
      setResult(parsed);
    } catch (e) {
      setErreur(ui.erreur);
    }
    setLoading(false);
  };

  const handleCopy = () => {
    if (result?.courrier_genere) {
      navigator.clipboard.writeText(result.courrier_genere).then(() => {
        setCopied(true);
        setTimeout(() => setCopied(false), 3000);
      });
    }
  };

  const reset = () => {
    setTexte(''); setContexte(''); setResult(null);
    setErreur(null); setCopied(false);
  };

  const URGENCE_CONFIG = {
    haute:    { label: ui.urgences.haute.label,    bg: '#FEE2E2', color: '#CE0500', border: '#FCCACA' },
    moyenne:  { label: ui.urgences.moyenne.label,  bg: '#FEF3C7', color: '#B45309', border: '#FDE68A' },
    faible:   { label: ui.urgences.faible.label,   bg: '#D1FAE5', color: '#065F46', border: '#A7F3D0' },
    inconnue: { label: ui.urgences.inconnue.label, bg: '#E8EDFF', color: '#003189', border: '#C7D7FF' },
  };

  const PRIO_CONFIG = {
    rouge:  { label: ui.priorites.rouge.label,  bg: '#FEE2E2', color: '#CE0500', border: '#FCCACA', dot: '#CE0500' },
    orange: { label: ui.priorites.orange.label, bg: '#FEF3C7', color: '#B45309', border: '#FDE68A', dot: '#E05D00' },
    vert:   { label: ui.priorites.vert.label,   bg: '#D1FAE5', color: '#065F46', border: '#A7F3D0', dot: '#169B62' },
  };

  const PROBLEME_COLORS = {
    flou: '#E05D00', contradiction: '#CE0500', suspect: '#B45309',
    abusif: '#991B1B', illegal: '#7F1D1D', omission: '#555',
  };

  const urg = result ? (URGENCE_CONFIG[result.urgence] || URGENCE_CONFIG.inconnue) : null;
  const categorieKeys = Object.keys(ui.categories);
  const modeKeys = Object.keys(ui.modes);

  const cardStyle = {
    background: '#fff', border: '1.5px solid #E0E0EE',
    borderRadius: 18, padding: isMobile ? '1.2rem' : '1.5rem', marginBottom: 12,
  };

  const sectionLabel = {
    fontSize: 10 * scale, fontWeight: 700, color: '#888',
    letterSpacing: '0.08em', textTransform: 'uppercase', marginBottom: 10,
  };

  return (
    <div style={{ minHeight: '100vh', direction: isRTL ? 'rtl' : 'ltr', background: '#F5F5FE' }}>
      <AppHeader
        onNavigate={onNavigate}
        onBack={() => onNavigate('home')}
        backLabel={ui.backLabel}
        large={large} toggleText={toggleText}
        t={t} isRTL={isRTL} lang={lang} switchLang={switchLang} onDiagnostic={onDiagnostic}
      />

      <main style={{ maxWidth: 720, margin: '0 auto', padding: isMobile ? '1.5rem 1rem 5rem' : '2.5rem 1.5rem 5rem' }}>

        {/* ── HEADER PAGE ── */}
        <div style={{ marginBottom: 24 }}>
          <div style={{
            display: 'inline-flex', alignItems: 'center', gap: 8,
            background: '#FEE2E2', border: '1px solid #FCCACA',
            borderRadius: 100, padding: '4px 14px', marginBottom: 14,
          }}>
            <span style={{ fontSize: 13, fontWeight: 700, color: '#CE0500', letterSpacing: '0.02em' }}>
              {ui.badge}
            </span>
          </div>
          <h1 style={{
            fontFamily: 'Fraunces, serif',
            fontSize: isMobile ? 24 * scale : 30 * scale,
            fontWeight: 700, color: '#1A1A1A', lineHeight: 1.2, marginBottom: 10,
          }}>
            {ui.title}
          </h1>
          <p style={{ fontSize: 15 * scale, color: '#555', lineHeight: 1.6 }}>
            {ui.intro}
          </p>
        </div>

        {/* ── FORMULAIRE ── */}
        {!result && (
          <div style={{ background: '#fff', border: '1.5px solid #E0E0EE', borderRadius: 20, padding: isMobile ? '1.2rem' : '1.8rem' }}>

            {/* CATÉGORIES */}
            <div style={{ marginBottom: 20 }}>
              <div style={{ fontSize: 13 * scale, fontWeight: 700, color: '#1A1A1A', marginBottom: 10 }}>
                {ui.labelCategorie}
              </div>
              <div style={{
                display: 'grid',
                gridTemplateColumns: isMobile ? 'repeat(2, 1fr)' : 'repeat(4, 1fr)',
                gap: 8,
              }}>
                {categorieKeys.map(key => {
                  const cat = ui.categories[key];
                  const isActive = categorie === key;
                  return (
                    <button key={key} onClick={() => setCategorie(key)} style={{
                      display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 4,
                      padding: '10px 8px', borderRadius: 12, cursor: 'pointer',
                      border: `2px solid ${isActive ? '#003189' : '#E0E0EE'}`,
                      background: isActive ? '#E8EDFF' : '#F5F5FE',
                      transition: 'all 0.15s ease',
                    }}>
                      <span style={{ fontSize: 20 }}>{cat.icon}</span>
                      <span style={{ fontSize: isMobile ? 10 : 11, fontWeight: 700, color: isActive ? '#003189' : '#555', textAlign: 'center', lineHeight: 1.3 }}>
                        {cat.label}
                      </span>
                    </button>
                  );
                })}
              </div>
            </div>

            {/* MODES */}
            <div style={{ marginBottom: 20 }}>
              <div style={{ fontSize: 13 * scale, fontWeight: 700, color: '#1A1A1A', marginBottom: 10 }}>
                {ui.labelMode}
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: isMobile ? 'repeat(2, 1fr)' : 'repeat(4, 1fr)', gap: 8 }}>
                {modeKeys.map(key => {
                  const m = ui.modes[key];
                  const isActive = mode === key;
                  const modeColors = {
                    expliquer: '#003189', procedure: '#169B62',
                    courrier: '#7B5EA7', detecter: '#CE0500',
                  };
                  const col = modeColors[key];
                  return (
                    <button key={key} onClick={() => setMode(key)} style={{
                      display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 5,
                      padding: '12px 8px', borderRadius: 12, cursor: 'pointer',
                      border: `2px solid ${isActive ? col : '#E0E0EE'}`,
                      background: isActive ? `${col}12` : '#F5F5FE',
                      transition: 'all 0.15s ease',
                    }}>
                      <span style={{ fontSize: 22 }}>{m.icon}</span>
                      <span style={{ fontSize: isMobile ? 10 : 11, fontWeight: 700, color: isActive ? col : '#555', textAlign: 'center', lineHeight: 1.3 }}>
                        {m.label}
                      </span>
                      {!isMobile && (
                        <span style={{ fontSize: 10, color: '#888', textAlign: 'center', lineHeight: 1.3 }}>
                          {m.desc}
                        </span>
                      )}
                    </button>
                  );
                })}
              </div>
            </div>

            {/* NUMÉROS UTILES — visibles dès sélection catégorie */}
            <NumerosUtiles categorie={categorie} scale={scale} isMobile={isMobile} />

            {/* TEXTAREA */}
            <label style={{ display: 'block', fontSize: 13 * scale, fontWeight: 600, color: '#1A1A1A', marginBottom: 8, marginTop: 20 }}>
              {ui.labelTexte}
            </label>
            <textarea
              value={texte}
              onChange={e => setTexte(e.target.value)}
              placeholder={ui.placeholder}
              rows={isMobile ? 7 : 9}
              style={{
                width: '100%', borderRadius: 12, border: '1.5px solid #E0E0EE',
                background: '#F5F5FE', color: '#1A1A1A',
                fontSize: 14 * scale, padding: '12px 14px',
                fontFamily: 'DM Sans, sans-serif', lineHeight: 1.6,
                resize: 'vertical', outline: 'none', boxSizing: 'border-box',
              }}
              onFocus={e => e.target.style.borderColor = '#0063CB'}
              onBlur={e => e.target.style.borderColor = '#E0E0EE'}
            />

            <label style={{ display: 'block', fontSize: 13 * scale, fontWeight: 600, color: '#1A1A1A', marginTop: 16, marginBottom: 8 }}>
              {ui.labelCtx} <span style={{ fontWeight: 400, color: '#888' }}>{ui.optional}</span>
            </label>
            <input
              type="text"
              value={contexte}
              onChange={e => setContexte(e.target.value)}
              placeholder={ui.placeholderCtx}
              style={{
                width: '100%', borderRadius: 10, border: '1.5px solid #E0E0EE',
                background: '#F5F5FE', color: '#1A1A1A',
                fontSize: 14 * scale, padding: '10px 14px',
                fontFamily: 'DM Sans, sans-serif', outline: 'none', boxSizing: 'border-box',
              }}
              onFocus={e => e.target.style.borderColor = '#0063CB'}
              onBlur={e => e.target.style.borderColor = '#E0E0EE'}
            />

            <button
              onClick={handleAnalyser}
              disabled={loading || !texte.trim()}
              style={{
                marginTop: 20, width: '100%', padding: '14px', borderRadius: 12, border: 'none',
                background: texte.trim() && !loading ? '#003189' : '#C0C8E0',
                color: '#fff', fontSize: 15 * scale, fontWeight: 700,
                cursor: texte.trim() && !loading ? 'pointer' : 'not-allowed',
                fontFamily: 'DM Sans, sans-serif', transition: 'background 0.15s',
              }}
              onMouseEnter={e => { if (texte.trim() && !loading) e.currentTarget.style.background = '#002070'; }}
              onMouseLeave={e => { if (texte.trim() && !loading) e.currentTarget.style.background = '#003189'; }}
            >
              {loading ? ui.btnLoading : ui.btnAnalyser}
            </button>

            {erreur && (
              <div style={{ marginTop: 14, padding: '12px 14px', borderRadius: 10, background: '#FEE2E2', border: '1px solid #FCCACA', fontSize: 13 * scale, color: '#CE0500' }}>
                {erreur}
              </div>
            )}

            <p style={{ marginTop: 14, fontSize: 11 * scale, color: '#AAA', textAlign: 'center', lineHeight: 1.5 }}>
              {ui.disclaimer}
            </p>
          </div>
        )}

        {/* ── RÉSULTATS ── */}
        {result && (
          <div>

            {/* Alerte juridique */}
            {result.alerte_juridique && result.alerte_juridique_message && (
              <div style={{ background: '#FEE2E2', border: '1.5px solid #FCCACA', borderRadius: 14, padding: '14px 16px', marginBottom: 14, display: 'flex', gap: 12, alignItems: 'flex-start' }}>
                <span style={{ fontSize: 20, flexShrink: 0 }}>⚠️</span>
                <div style={{ fontSize: 13 * scale, color: '#7F1D1D', lineHeight: 1.6 }}>{result.alerte_juridique_message}</div>
              </div>
            )}

            {/* Incertitude */}
            {result.incertitude && result.incertitude !== 'Aucune' && (
              <div style={{ background: '#FEF3C7', border: '1px solid #FDE68A', borderRadius: 14, padding: '12px 16px', marginBottom: 14, fontSize: 12 * scale, color: '#78350F', lineHeight: 1.5 }}>
                ℹ️ {ui.infoManquante} {result.incertitude}
              </div>
            )}

            {/* BLOC 1 — Ce qu'ils disent */}
            <div style={cardStyle}>
              <div style={sectionLabel}>{ui.blocDit}</div>
              <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 12, flexWrap: 'wrap' }}>
                <span style={{ fontSize: 14 * scale, fontWeight: 700, color: '#1A1A1A' }}>{result.expediteur}</span>
                {urg && (
                  <span style={{ fontSize: 11 * scale, fontWeight: 700, background: urg.bg, color: urg.color, border: `1px solid ${urg.border}`, borderRadius: 100, padding: '3px 12px' }}>
                    {urg.label}
                  </span>
                )}
              </div>
              <p style={{ fontSize: 14 * scale, color: '#1A1A1A', lineHeight: 1.65 }}>{result.resume}</p>
            </div>

            {/* BLOC 2 — Ce qu'ils veulent (modes non-courrier) */}
            {result.urgence !== 'inconnue' && result.delai_brut && mode !== 'courrier' && (
              <div style={cardStyle}>
                <div style={sectionLabel}>{ui.blocVeulent}</div>
                <div style={{ marginBottom: 8 }}>
                  <span style={{ fontSize: 12 * scale, color: '#888' }}>{ui.delaiLabel} </span>
                  <span style={{ fontSize: 13 * scale, fontWeight: 600, color: '#1A1A1A' }}>{result.delai_brut}</span>
                </div>
                <p style={{ fontSize: 14 * scale, color: '#1A1A1A', lineHeight: 1.65 }}>{result.delai_interpretation}</p>
              </div>
            )}

            {/* BLOC 3 — Actions (expliquer + procedure) */}
            {(mode === 'expliquer' || mode === 'procedure') && result.actions && result.actions.length > 0 && (
              <div style={cardStyle}>
                <div style={sectionLabel}>{ui.blocFaites}</div>
                {result.actions.map((action, i) => {
                  const p = PRIO_CONFIG[action.priorite] || PRIO_CONFIG.vert;
                  return (
                    <div key={i} style={{
                      display: 'flex', gap: 12, alignItems: 'flex-start',
                      paddingBottom: i < result.actions.length - 1 ? 14 : 0,
                      marginBottom: i < result.actions.length - 1 ? 14 : 0,
                      borderBottom: i < result.actions.length - 1 ? '1px solid #F0F0F8' : 'none',
                    }}>
                      <div style={{ flexShrink: 0, marginTop: 4, width: 10, height: 10, borderRadius: '50%', background: p.dot }} />
                      <div style={{ flex: 1 }}>
                        <div style={{ fontSize: 13 * scale, color: '#1A1A1A', lineHeight: 1.55, marginBottom: 4 }}>{action.texte}</div>
                        {action.documents && (
                          <div style={{ fontSize: 11 * scale, color: '#0063CB', marginBottom: 4 }}>📎 {action.documents}</div>
                        )}
                        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                          <span style={{ fontSize: 10 * scale, fontWeight: 700, background: p.bg, color: p.color, border: `1px solid ${p.border}`, borderRadius: 100, padding: '2px 8px' }}>{p.label}</span>
                          <span style={{ fontSize: 11 * scale, color: '#888' }}>{action.delai && action.delai !== 'Aucun' ? action.delai : ui.aucunDelai}</span>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            )}

            {/* BLOC Risques (mode procedure) */}
            {mode === 'procedure' && result.risques && (
              <div style={{ ...cardStyle, background: '#FFF8F0', border: '1.5px solid #FDE68A' }}>
                <div style={{ ...sectionLabel, color: '#B45309' }}>{ui.blocRisques}</div>
                <p style={{ fontSize: 13 * scale, color: '#78350F', lineHeight: 1.6 }}>{result.risques}</p>
              </div>
            )}

            {/* BLOC Courrier généré (mode courrier) */}
            {mode === 'courrier' && result.courrier_genere && (
              <div style={cardStyle}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 12, flexWrap: 'wrap', gap: 8 }}>
                  <div style={sectionLabel}>{ui.blocCourrier}</div>
                  <button
                    onClick={handleCopy}
                    style={{
                      display: 'flex', alignItems: 'center', gap: 6,
                      background: copied ? '#D1FAE5' : '#E8EDFF',
                      border: `1.5px solid ${copied ? '#A7F3D0' : '#C7D7FF'}`,
                      color: copied ? '#065F46' : '#003189',
                      borderRadius: 8, padding: '6px 14px',
                      fontSize: 12 * scale, fontWeight: 700, cursor: 'pointer',
                      transition: 'all 0.2s ease',
                    }}>
                    {copied ? ui.btnCopie : ui.btnCopier}
                  </button>
                </div>
                {/* Affichage inline dans la page */}
                <div style={{
                  background: '#F5F5FE', border: '1px solid #E0E0EE',
                  borderRadius: 12, padding: '16px',
                  fontSize: 13 * scale, color: '#1A1A1A',
                  lineHeight: 1.8, whiteSpace: 'pre-wrap',
                  fontFamily: 'DM Sans, sans-serif',
                }}>
                  {result.courrier_genere}
                </div>
                {result.instructions_envoi && (
                  <div style={{ marginTop: 12, padding: '12px 14px', borderRadius: 10, background: '#E8EDFF', border: '1px solid #C7D7FF' }}>
                    <div style={{ fontSize: 11 * scale, fontWeight: 700, color: '#003189', marginBottom: 4 }}>{ui.instructionsEnvoi}</div>
                    <div style={{ fontSize: 12 * scale, color: '#0063CB', lineHeight: 1.5 }}>{result.instructions_envoi}</div>
                  </div>
                )}
              </div>
            )}

            {/* BLOC Problèmes détectés (mode detecter) */}
            {mode === 'detecter' && (
              <>
                {result.legitimite && (
                  <div style={{
                    ...cardStyle,
                    background: result.legitimite === 'legitime' ? '#D1FAE5' : result.legitimite === 'suspect' ? '#FEE2E2' : '#E8EDFF',
                    border: `1.5px solid ${result.legitimite === 'legitime' ? '#A7F3D0' : result.legitimite === 'suspect' ? '#FCCACA' : '#C7D7FF'}`,
                  }}>
                    <div style={{ fontSize: 14 * scale, fontWeight: 700, color: result.legitimite === 'legitime' ? '#065F46' : result.legitimite === 'suspect' ? '#CE0500' : '#003189' }}>
                      {ui.legitimite[result.legitimite] || ui.legitimite.inconnu}
                    </div>
                  </div>
                )}
                {result.problemes_detectes && result.problemes_detectes.length > 0 && (
                  <div style={cardStyle}>
                    <div style={sectionLabel}>{ui.blocProblemes}</div>
                    {result.problemes_detectes.map((pb, i) => {
                      const col = PROBLEME_COLORS[pb.type] || '#555';
                      return (
                        <div key={i} style={{
                          marginBottom: i < result.problemes_detectes.length - 1 ? 16 : 0,
                          paddingBottom: i < result.problemes_detectes.length - 1 ? 16 : 0,
                          borderBottom: i < result.problemes_detectes.length - 1 ? '1px solid #F0F0F8' : 'none',
                        }}>
                          <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 6 }}>
                            <span style={{ fontSize: 10 * scale, fontWeight: 700, background: `${col}15`, color: col, border: `1px solid ${col}40`, borderRadius: 100, padding: '2px 10px' }}>
                              {ui.problemeTypes[pb.type] || pb.type}
                            </span>
                          </div>
                          <div style={{ fontSize: 13 * scale, color: '#1A1A1A', lineHeight: 1.55, marginBottom: 6 }}>{pb.description}</div>
                          {pb.recommandation && (
                            <div style={{ fontSize: 12 * scale, color: '#0063CB', lineHeight: 1.5, fontStyle: 'italic' }}>→ {pb.recommandation}</div>
                          )}
                        </div>
                      );
                    })}
                  </div>
                )}
                {result.actions && result.actions.length > 0 && (
                  <div style={cardStyle}>
                    <div style={sectionLabel}>{ui.blocFaites}</div>
                    {result.actions.map((action, i) => {
                      const p = PRIO_CONFIG[action.priorite] || PRIO_CONFIG.vert;
                      return (
                        <div key={i} style={{ display: 'flex', gap: 12, alignItems: 'flex-start', paddingBottom: i < result.actions.length - 1 ? 14 : 0, marginBottom: i < result.actions.length - 1 ? 14 : 0, borderBottom: i < result.actions.length - 1 ? '1px solid #F0F0F8' : 'none' }}>
                          <div style={{ flexShrink: 0, marginTop: 4, width: 10, height: 10, borderRadius: '50%', background: p.dot }} />
                          <div style={{ flex: 1 }}>
                            <div style={{ fontSize: 13 * scale, color: '#1A1A1A', lineHeight: 1.55, marginBottom: 4 }}>{action.texte}</div>
                            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                              <span style={{ fontSize: 10 * scale, fontWeight: 700, background: p.bg, color: p.color, border: `1px solid ${p.border}`, borderRadius: 100, padding: '2px 8px' }}>{p.label}</span>
                              <span style={{ fontSize: 11 * scale, color: '#888' }}>{action.delai && action.delai !== 'Aucun' ? action.delai : ui.aucunDelai}</span>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                )}
              </>
            )}

            {/* Module recommandé */}
            {result.module_recommande && result.module_recommande !== 'aucun' && MODULE_LABELS[result.module_recommande] && (
              <div style={{ background: '#E8EDFF', border: '1.5px solid #C7D7FF', borderRadius: 18, padding: isMobile ? '1rem 1.2rem' : '1.2rem 1.5rem', marginBottom: 12 }}>
                <div style={{ ...sectionLabel, color: '#003189' }}>{ui.blocPlus}</div>
                <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 6 }}>
                  <span style={{ fontSize: 22 }}>{MODULE_LABELS[result.module_recommande].icon}</span>
                  <span style={{ fontSize: 14 * scale, fontWeight: 700, color: '#003189' }}>{MODULE_LABELS[result.module_recommande].label}</span>
                </div>
                <p style={{ fontSize: 12 * scale, color: '#0063CB', marginBottom: 12, lineHeight: 1.5 }}>{result.module_raison}</p>
                <button
                  onClick={() => onNavigate('module', result.module_recommande)}
                  style={{ background: '#003189', color: '#fff', border: 'none', padding: '10px 20px', borderRadius: 10, fontSize: 13 * scale, fontWeight: 700, cursor: 'pointer', fontFamily: 'DM Sans, sans-serif' }}>
                  {ui.btnModule}
                </button>
              </div>
            )}

            {/* Disclaimer + Reset */}
            {/* NUMÉROS UTILES — dans les résultats */}
            <NumerosUtiles categorie={categorie} scale={scale} isMobile={isMobile} />

            <p style={{ fontSize: 11 * scale, color: '#AAA', textAlign: 'center', lineHeight: 1.5, marginBottom: 16, marginTop: 16 }}>
              {ui.disclaimerFin}
            </p>
            <button
              onClick={reset}
              style={{
                width: '100%', padding: '12px', borderRadius: 12,
                border: '1.5px solid #E0E0EE', background: '#fff',
                fontSize: 13 * scale, fontWeight: 600, color: '#555',
                cursor: 'pointer', fontFamily: 'DM Sans, sans-serif',
              }}
              onMouseEnter={e => e.currentTarget.style.background = '#F5F5FE'}
              onMouseLeave={e => e.currentTarget.style.background = '#fff'}>
              {ui.btnReset}
            </button>

          </div>
        )}
      </main>
    </div>
  );
}
